import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { ISchool } from "src/app/core/models/academic";

export const SchoolActions = createActionGroup({
    source: 'School',
    events: {
        'Select School': props<{ id: string }>(),
        'Load Schools': emptyProps(),
        'Load Schools Success': props<{ schools: ISchool[] }>(),
        'Load Schools Failure': props<{ error: unknown }>(),
    }
});